<template>
  <div id="app">
    <navmain></navmain>
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'app'
}
</script>

<style>
  :root {
    --color-green: #629755;
    --color-yellow: #ffc66d;
    --color-purple: #9876aa;
    --color-gray: #424445;
    --color-black: #323232;
  }
  body {
    background-color: var(--color-gray);
    color: var(--color-green);
    font-family: 'Source Code Pro', sans-serif;
    font-size: 16px;
    line-height: 1.5;
    margin: 0;
  }
  a {
    text-decoration: none;
    color: var(--color-purple);
    transition: color .15s ease-out;
  }

  a:hover {
    color: var(--color-yellow);
  }

  i {
    font-style: normal;
    border-bottom: 1px dashed;
  }

  h1, h2, h3, h4, p {
    margin: 0 0 1rem;
  }

  .content-block {
    background-color: var(--color-black);
    margin: 1rem auto;
    max-width: 800px;
    padding: 1rem;
  }
</style>



// WEBPACK FOOTER //
// App.vue?1d470ffd